<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <applicants-import-index/>
        </v-layout>
    </v-container>
</template>
<script>
    import ApplicantsImportIndex from "../../../../components/admin/Students/ApplicantsImport/ApplicantsImportIndex";
    export default  {
        components: {
            ApplicantsImportIndex,
        }
    }
</script>